function getDateFingerprint(prefix = 'empty') {
  return `${prefix}-${Date.now().toString()}`;
}

export default getDateFingerprint;
